<template>
  <div id="header-component">
    <v-card id="header-card" class="overflow-hidden rounded-0" elevation="5">
      <v-progress-linear color="#C850C0" indeterminate height="2" absolute v-show="loading"></v-progress-linear>
      <v-app-bar color="primary" height="50" align="center" dark>
        <v-card class="mx-auto" width="100%" color="transparent" elevation="0">
          <div class="d-flex justify-space-between align-center">
            <PanelBrand />
            <div class="flex-grow-1 pl-2 pr-5">
              <div class="panel-nav-menu">
                <v-btn to="/" class="px-2 m-1" dark text>
                  <v-icon left class="mr-0 ml-0" size="25">mdi-home</v-icon>
                </v-btn>
                <div
                  id="panelNavContainer"
                  class="mr-2"
                  :key="key"
                  v-for="(nav, key) in panelNavigation.child"
                  v-show="nav.icon !== ''"
                >
                  <v-btn
                    :to="`${panelNavigation.link}/${nav.link}`"
                    :class="[nav.link === 'urunler/yeni-urun' ? 'nav-pin' : '']"
                    v-if="(nav.child.length === 0 || navChildsLength(nav.child) === 0)"
                    v-show="nav.icon !== ''"
                    dark
                    text
                    class="text-capitalize"
                  >
                    <v-icon left outlined>{{nav.icon}}</v-icon>
                    {{nav.name}}
                  </v-btn>

                  <v-menu v-else open-on-hover bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        ref="submenuButton"
                        :to="`${panelNavigation.link}/${nav.link}`"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        text
                        class="text-capitalize"
                      >
                        <v-icon left>{{nav.icon}}</v-icon>
                        {{nav.name}}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in nav.child"
                        :key="index"
                        v-show="item.icon !== ''"
                        v-ripple
                        :to="`${panelNavigation.link}/${nav.link}/${item.link}`"
                        class="panel-nav-item pl-3 pr-8"
                      >
                          <v-list-item-content>
                            <v-list-item-title class="text-subtitle-2">
                            <v-icon left>{{item.icon}}</v-icon>
                              {{ item.name }}
                            </v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="panel-extend-navigation-btn">
                  <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-badge
                        color="blue"
                        bottom
                        :offset-y="15"
                        :offset-x="10"
                        :content="$t('PANEL.HEADER.SUB_MENU_LABEL')"
                        :value="!(!!extendNavigation)"
                      >
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          :light="!(!!extendNavigation)"
                          fab
                          small
                          depressed
                          @click="navExtend"
                        >
                          <v-icon>mdi-menu</v-icon>
                        </v-btn>
                      </v-badge>
                    </template>
                    <span>{{$t('PANEL.HEADER.SUB_MENU_INFO')}}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <HeaderManagement />
          </div>
        </v-card>
      </v-app-bar>
    </v-card>
    <v-card elevation="0" rounded="0" v-show="extendNavigation">
      <div class="panel-navigation-extend primary d-flex align-center py-1 px-4">
        <div
          class="panel-navigation-extend-item mr-2"
          :key="key"
          v-for="(nav, key) in panelNavigationExtend.child"
        >
          <v-btn
            v-if="nav.child.length === 0 || navChildsLength(nav.child) === 0"
            :to="`${panelNavigationExtend.link}/${nav.link}`"
            v-show="nav.icon !== ''"
            dark
            text
            class="text-capitalize"
          >
            <v-icon left outlined>{{nav.icon}}</v-icon>
            {{nav.name}}
          </v-btn>

          <v-menu v-else open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn href="#" dark v-bind="attrs" v-on="on" text class="text-capitalize">
                <v-icon left>{{nav.icon}}</v-icon>
                {{nav.name}}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in nav.child"
                :key="index"
                v-show="item.icon !== ''"
                v-ripple
                class="panel-nav-items-container text-capitalize"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-list-item-title class="panel-nav-items" :class="hover ? 'nav-is-hover' : ''">
                    <RouterLink
                      class="panel-nav-a-items text-body-2"
                      :to="`${panelNavigationExtend.link}/${nav.link}/${item.link}`"
                    >
                      <v-icon size="1rem" color="primary" left>{{item.icon}}</v-icon>
                      {{ item.name }}
                    </RouterLink>
                  </v-list-item-title>
                </v-hover>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-card>
    <BreadCrumbs />
  </div>
</template>

<script>
import BreadCrumbs from "@/components/Template/BreadCrumbs";
import { mapState } from "vuex";
import PanelBrand from "@/components/Template/PanelBrand.vue";
import HeaderManagement from "@/components/Template/HeaderManagement.vue";
export default {
  name: "Desktop",
  components: {
    BreadCrumbs,
    PanelBrand,
    HeaderManagement
  },
  data(vm) {
    return {
      extendNavigation: vm.isExtendNav(),
      systemSettingsMenu: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loadingStatus,
      panelNavigation: state => state.panelNavigation,
      panelNavigationExtend: state => state.panelNavigationExtend,
      widgetsLists: state => state.Widget.WidgetLists.widgetLists
    })
  },
  methods: {
    navChildsLength(child) {
      let navs = Object.keys(child).filter(n => child[n].icon !== "");
      return navs.length;
    },
    isExtendNav() {
      return (this.extendNavigation = localStorage.getItem("nav-extend")
        ? true
        : false);
    },
    navExtend() {
      let extStatus = this.isExtendNav();
      if (extStatus) {
        localStorage.removeItem("nav-extend");
      } else {
        localStorage.setItem("nav-extend", 1);
      }
      this.isExtendNav();
    }
  }
};
</script>

<style>
.panel-nav-item {
  transition: .3s background;
}
.panel-nav-item:hover {
  background-color: #ddd;
}
</style>